var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17.8696C12.8837 17.8696 13.6 16.3038 13.6 15.3913C13.6 14.4788 12.8837 13.7391 12 13.7391C11.1163 13.7391 10.4 14.4788 10.4 15.3913C10.4 16.3038 11.1163 17.8696 12 17.8696Z",
    fill: "#5A6B9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4 8.78261C6.4 5.58896 8.90721 3 12 3C15.0928 3 17.6 5.58896 17.6 8.78261V9.6087C18.9255 9.6087 20 10.7183 20 12.087V19.5217C20 20.8904 18.9255 22 17.6 22H6.4C5.07452 22 4 20.8904 4 19.5217V12.087C4 10.7183 5.07452 9.6087 6.4 9.6087V8.78261ZM16 8.78261V9.6087H8V8.78261C8 6.50143 9.79086 4.65217 12 4.65217C14.2091 4.65217 16 6.50143 16 8.78261ZM5.6 12.087C5.6 11.6307 5.95817 11.2609 6.4 11.2609H17.6C18.0418 11.2609 18.4 11.6307 18.4 12.087V19.5217C18.4 19.978 18.0418 20.3478 17.6 20.3478H6.4C5.95817 20.3478 5.6 19.978 5.6 19.5217V12.087Z",
    fill: "#5A6B9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.7d71710f36d56df92bb64076fe5a032d.svg";
export { ForwardRef as ReactComponent };